import React, { useState, useRef, useEffect } from "react";
import "../table/BreadCrum/breadcrum.scss";
import SortIcons from "constants/Homepage/ysafe/iconFunctions/sortIcons";

const TRUNCATE_THRESHOLD = 4;
const VISIBLE_TAIL = 2;

const BreadcrumbExternalShare = ({ currentPath, setCurrentPath, dupCurrentPath, activeTab, allFiles = null, setdupCurrentPath }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const path = dupCurrentPath;
  const pathLength = path.length;
  const isExternalShared = pathLength > 0 && path[0] === "external_shared";
  
  // For external_shared, we want to show it as the root and exclude "All Files"
  // If path starts with external_shared, remove it from the displayed path since we'll show it separately
  const displayPath = isExternalShared ? path.slice(1) : path;
  const displayPathLength = displayPath.length;
  const shouldTruncate = displayPathLength > TRUNCATE_THRESHOLD;
  const tailStart = shouldTruncate ? displayPathLength - VISIBLE_TAIL : 0;

  const handleNavigation = (actualIndex) => {
    // actualIndex is already adjusted in renderSegment and dropdown handlers
    const newPath = currentPath.slice(0, actualIndex + 1);
    const newDupPath = dupCurrentPath.slice(0, actualIndex + 1);
    setCurrentPath(newPath);
    setdupCurrentPath(newDupPath);
    setDropdownOpen(false);
  };

  const handleRootClick = () => {
    if (isExternalShared) {
      // For external_shared, go back to root (external_shared)
      setCurrentPath(["external_shared"]);
      setdupCurrentPath(["external_shared"]);
    } else if (activeTab + 1 === 2) {
      setCurrentPath(["shared"]);
      setdupCurrentPath([]);
    } else {
      setCurrentPath([]);
      setdupCurrentPath([]);
    }
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderSegment = (folder, displayIndex, isCurrent) => {
    // For external_shared, adjust the index to account for external_shared being at position 0
    const actualIndex = isExternalShared ? displayIndex + 1 : displayIndex;
    return (
      <span key={displayIndex}>
        <span className="arrowBox">
          <SortIcons type="arrow" color="var(--text-grey-strong)" />
        </span>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleNavigation(actualIndex)}
          className={isCurrent ? "current" : "previous"}
          title={folder}
        >
          {folder}
        </span>
      </span>
    );
  };

  return (
    <nav className="breadcrumContainer" ref={dropdownRef}>
      {/* For external_shared, show it as root instead of "All Files" */}
      {isExternalShared ? (
        <span style={{ cursor: "pointer" }} onClick={handleRootClick} className="allFiles">
          external_shared
        </span>
      ) : (allFiles ?? pathLength > 0) && (
        <span style={{ cursor: "pointer" }} onClick={handleRootClick} className="allFiles">
          {activeTab + 1 === 2 ? "Shared With Me" : "All Files"}
        </span>
      )}

      {!shouldTruncate &&
        displayPath.map((folder, index) =>
          renderSegment(folder, index, index === displayPathLength - 1)
        )}

      {shouldTruncate && (
        <>
          <span className="arrowBox">
            <SortIcons type="arrow" color="var(--text-grey-strong)" />
          </span>
          <span className="breadcrumEllipsisWrap">
            <span
              className="breadcrumEllipsis"
              onClick={() => setDropdownOpen((o) => !o)}
              title={displayPath.slice(0, tailStart).join(" > ")}
            >
              ...
            </span>
            {dropdownOpen && (
              <div className="breadcrumDropdown">
                {displayPath.slice(0, tailStart).map((folder, i) => {
                  // For external_shared, adjust the index to account for external_shared being at position 0
                  const actualIndex = isExternalShared ? i + 1 : i;
                  return (
                    <button
                      key={i}
                      type="button"
                      className="breadcrumDropdownItem"
                      onClick={() => handleNavigation(actualIndex)}
                    >
                      {folder}
                    </button>
                  );
                })}
              </div>
            )}
          </span>
          {displayPath.slice(tailStart).map((folder, i) => {
            const displayIndex = tailStart + i;
            return renderSegment(folder, displayIndex, displayIndex === displayPathLength - 1);
          })}
        </>
      )}
    </nav>
  );
};

export default BreadcrumbExternalShare;
